export enum ROLE {
  ADMIN = "ROLE_ADMIN",



  ASESOR_BASE = "ROLE_ASESOR_BASE",
  ASESOR = "ROLE_ASESOR",

  SUPERVISOR = "ROLE_SUPERVISOR",


  GERENTE_JR = "ROLE_GERENTE_JR",
  GERENTE = "ROLE_GERENTE",
  GERENTE_CONSOLIDADO = "ROLE_GERENTE_CONSOLIDADO",



  DEPARTAMENTO = "ROLE_DEPARTAMENTO",
  ADMIN_MESA = "ROLE_ADMIN_MESA",


  RECURSOS_HUMANOS = "ROLE_RECURSOS_HUMANOS",

  ASEGURADORA = "ROLE_ASEGURADORA",


  
  VERIFICADOR_TELEFONICO = "ROLE_VERIFICADOR_TELEFONICO",

  ASISTENTE = "ROLE_ASISTENTE",


  DIRECTOR_COMERCIAL = "ROLE_DIRECTOR_COMERCIAL",
  ROLE_DIRECTOR_COMERCIAL = "ROLE_DIRECTOR_COMERCIAL",


  DIRECTOR_EXPANSION = "ROLE_DIRECTOR_EXPANSION",
  DIRECTOR_GENERAL = "ROLE_DIRECTOR_GENERAL",








  GERENTE_REGIONAL = "ROLE_GERENTE_REGIONAL",


  NOMINA = "ROLE_NOMINA",
  PAGOS = "ROLE_PAGOS",


  ROLE_CONTABILIDAD = "ROLE_CONTABILIDAD",
  ROLE_FINANZAS_CAPTURAS = "ROLE_FINANZAS_CAPTURAS",





  
  ROLE_CLIENTE = "ROLE_CLIENTE"



  // CAPTURE = "ROLE_CAPTURE",
  // ANALYST = "ROLE_ANALYST",
  // VIEW = "ROLE_VIEW",
}